import { verifyAccountNumber } from "../actions/surveyActions";

export const APIS = {
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  refreshToken: {
    method: "POST",
    path: `${process.env.REACT_APP_API_REFRESH_URL}${process.env.REACT_APP_FIREBASE_API_KEY}`,
  },
  // createScout: {
  //   method: "POST",
  //   path: "/scout_create_scout",
  // },
  // getPartners: {
  //   method: "POST",
  //   path: "/scout_get_partners",
  // },
  // getScout: {
  //   method: "POST",
  //   path: "/scout_get_scout",
  // },
  getCampaigns: {
    method: "GET",
    path: "/scout/campaigns",
  },
  getQuestions: {
    method: "GET",
    path: "/scout/questions",
  },
  // addResponse: {
  //   method: "POST",
  //   path: "/scout_add_response",
  // },

  addResponse: {
    method: "POST",
    path: "/scout/response",
  },

  getMissingData: {
    method: "POST",
    path: "/scout/missingdata",
  },

  // setEndCampaign: {
  //   method: "POST",
  //   path: "/scout_end_campaign",
  // },

  setEndCampaign: {
    method: "POST",
    path: "/scout/endcampaign",
  },

  addMultiMediaRequest: {
    method: "POST",
    path: "/scout_add_multimedia_request_response",
  },

  // getBanks: {
  //   method: "POST",
  //   path: "/scout_get_banks",
  // },

  verifyAccountNumber: {
    method: "POST",
    path: "/scout_verify_account_number",
  },

  convertAmount: {
    method: "POST",
    path: "/scout/convertamount",
  },

  cashOutToBank: {
    method: "POST",
    path: "/scout/cashout",
  },

  cashOutAfrica: {
    method: "POST",
    path: "/scout_redeem_credits",
  },

  cashOutWithPaga: {
    method: "POST",
    path: "/redeem_credits",
  },

  sendSMS: {
    method: "POST",
    path: "/versus_v2_send_sms",
  },

  pendingResponses: {
    method: "POST",
    path: "/scout_get_request_responses",
  },
  sendWhatsappMessage: {
    method: "POST",
    path: "/send_whatsapp_message",
  },
  saveWebToken: {
    method: "POST",
    path: "/scout_save_web_token",
  },
  // createNewSignUp: {
  //   method: "POST",
  //   path: "/scout_validate_new_signup",
  // },
  // getStates: {
  //   method: "POST",
  //   path: "/scout_get_states",
  // },
  // getStatesLGA: {
  //   method: "POST",
  //   path: "/scout_get_states_lga",
  // },
  // updateScoutData: {
  //   method: "POST",
  //   path: "/scout_update_scout",
  // },
  updateScoutData: {
    method: "PUT",
    path: "/scout/scout",
  },

  endDemographicCampaign: {
    method: "POST",
    path: "/scout/enddemographiccampaign",
  },
  deleteScout: {
    method: "POST",
    path: "/scout/deletescout",
  },

  // Demographic Endpoints
  updateChildrenInHouseHold: {
    method: "POST",
    path: "/scout_update_children_in_household",
  },

  updateHouseHoldMonthlyIncome: {
    method: "POST",
    path: "/scout_update_household_monthly_income",
  },

  updateReligion: {
    method: "POST",
    path: "/scout_update_religion",
  },

  updateEmploymentStatus: {
    method: "POST",
    path: "/scout_update_employment_status",
  },

  updateIndustryAffiliation: {
    method: "POST",
    path: "/scout_update_industry_affiliation",
  },

  updatePersonalMonthlyIncome: {
    method: "POST",
    path: "/scout_update_personal_monthly_income",
  },

  updatePeopleInHousehold: {
    method: "POST",
    path: "/scout_update_people_in_household",
  },

  updateDob: {
    method: "POST",
    path: "/scout_update_dob",
  },

  updateTribe: {
    method: "POST",
    path: "/scout_update_tribe",
  },

  updateHighestEducationLevel: {
    method: "POST",
    path: "/scout_update_highest_education_level",
  },

  updateGender: {
    method: "POST",
    path: "/scout_update_gender",
  },

  updateMaritalStatus: {
    method: "POST",
    path: "/scout_update_marital_status",
  },

  updateSportsFan: {
    method: "POST",
    path: "/scout_update_sports_fan",
  },

  updateSoccerFan: {
    method: "POST",
    path: "/scout_update_soccer_fan",
  },

  updateFavoriteTeam: {
    method: "POST",
    path: "/scout_update_favorite_team",
  },

  //Without Firebase Endpoint

  getBanks: {
    method: "GET",
    path: "/scout/banks",
  },

  getScout: {
    method: "GET",
    path: "/scout/scout",
  },

  getPartners: {
    method: "GET",
    path: "/scout/partners",
  },

  createNewSignUp: {
    method: "POST",
    path: "/scout/validatenewsignup",
  },
  verifyAccountNumber: {
    method: "POST",
    path: "/scout/verifyaccount",
  },
  getStates: {
    method: "GET",
    path: "/enums/states",
  },
  getStatesLGA: {
    method: "GET",
    path: "/enums/lga",
  },

  createScout: {
    method: "POST",
    path: "/scout/scout",
  },
  scoutAuth: {
    method: "POST",
    path: "/auth/scoutauth",
  },

  scoutLogin: {
    method: "POST",
    path: "/auth/scoutlogin",
  },

  getMultimediaUploadUrl: {
    method: "POST",
    path: "/scout/mmuploadurl",
  },
  submitMultimediaResponse: {
    method: "POST",
    path: "/scout/multimediarequestresponse",
  },
};
